{
  "becameKindCurator_one": "ist Kuratorin oder Kurator jedes Elements von {{count}} Art",
  "becameKindCurator_other": "ist Kuratorin oder Kurator jedes Elements von {{count}} Arten",
  "by": "durch {{name}}",
  "changes": {
    "curation_granted": "ist Kuratorin oder Kurator {{scope}}",
    "curation_revoked": "ist nicht mehr Kuratorin oder Kurator {{scope}}",
    "group_changed": "Die Gruppe {{group}} wurde umbenannt oder verschoben",
    "group_curation_changed": "Die Gruppe {{group}} kuratiert jetzt {{kinds}}",
    "group_excluded": "Die Gruppe {{group}} der Installation ist nicht mehr aufgenommen",
    "group_grants_changed": "Was die Gruppe {{group}} erlaubt, hat sich geändert",
    "group_included": "Die Gruppe {{group}} der Installation wurde aufgenommen",
    "group_made": "Die Gruppe {{group}} wurde angelegt",
    "group_member_added": "ist jetzt in der Gruppe {{group}}",
    "group_member_removed": "ist nicht mehr in der Gruppe {{group}}",
    "group_order_changed": "Die Reihenfolge der Gruppen hat sich geändert",
    "group_overrides_changed": "Was die Gruppe {{group}} hier gibt, hat sich geändert",
    "group_removed": "Die Gruppe {{group}} wurde entfernt",
    "group_role_changed": "Die Gruppe {{group}} hat jetzt die Rolle {{role}}",
    "group_role_granted": "Die Gruppe {{group}} hat die Rolle {{role}} bekommen",
    "group_role_revoked": "Die Gruppe {{group}} hat hier keine Rolle mehr",
    "membership_granted": "ist beigetreten als {{role}}",
    "membership_revoked": "hat das Projekt verlassen",
    "project_deleted": "Das Projekt wurde gelöscht",
    "project_purged": "Das Projekt wurde endgültig gelöscht",
    "project_restored": "Das Projekt wurde wiederhergestellt",
    "project_role_changed": "ist jetzt {{role}}",
    "project_settings_changed": "hat die Regeln des Projekts geändert"
  },
  "empty": "Noch hat sich keine Berechtigung geändert.",
  "everyItemOf": "jedes Elements der Art {{kind}}",
  "groupCurationTaken": "Die Gruppe {{group}} kuratiert hier nichts mehr",
  "oneItemOf": "eines einzelnen Elements der Art {{kind}}",
  "reason": "Begründung: {{reason}}",
  "reconstructed": "aus Einträgen, die älter sind als der Verlauf",
  "removedAccount": "Ein entferntes Konto",
  "roles": {
    "contributor": "Mitwirkende Person",
    "project_administrator": "Projektadministration",
    "reader": "Lesende Person"
  },
  "rulesChanged": "Die Regeln des Projekts haben sich geändert: {{rules}}",
  "rulesFromDefaults": "Die Regeln des Projekts wurden aus den Vorgaben der Installation übernommen",
  "title": "Verlauf der Berechtigungen"
}
